
import React, { Component } from 'react'

import NotificationSystem from 'react-notification-system'
import Notification from 'react-web-notification'

class Notifications extends Component {

  constructor(props) {
    super(props)

    this.state = {
      ignore: true,
      title: ''
    }
    this.windowInFocus = null
    this.notificationSystem = null
  }


  componentWillUnmount() {
    window.removeEventListener("focus", this.onWindowFocus)
    window.removeEventListener("blur", this.onWindowBlur)
  }

    onWindowFocus = () => {
      this.windowInFocus = true
    }

    onWindowBlur = () => {
      this.windowInFocus = false
    }

    componentDidMount() {
      window.addEventListener("focus", this.onWindowFocus)
      window.addEventListener("blur", this.onWindowBlur)
      if (window) {
        if (!window.sfcrmdashboard) {
          window.sfcrmdashboard = []
        }
        window.sfcrmdashboard["notification"] = this
      } else {
        console.log("Error: window object not found, app not running in brwoser environment")
      }
    }
    componentDidUpdate(){
      if (window) {
        if (!window.sfcrmdashboard) {
          window.sfcrmdashboard = []
        }
        window.sfcrmdashboard["notification"] = this
      } else {
        console.log("Error: window object not found, app not running in brwoser environment")
      }
    }

    removeNotification = (uid) => {
      this.notificationSystem.removeNotification(uid)
    }

    showNotification = (notificationDetails) => {
      this.notificationSystem.addNotification({
        title: notificationDetails.title,
        message: notificationDetails.message,
        level: notificationDetails.level,
        position: 'tc',
        uid: notificationDetails.uid,
        autoDismiss: notificationDetails.autoDismiss ? notificationDetails.autoDismiss : 60,
        action: (notificationDetails.actionLabel) ? {
          label: notificationDetails.actionLabel,
          callback: function () {
            if (notificationDetails.actionCallback) {
              if (notificationDetails.callbackParameters)
                notificationDetails.actionCallback(notificationDetails.callbackParameters)
              else
                notificationDetails.actionCallback()
            }
          }
        } : null
      });

      // this.showWebNotification(notificationDetails)
    }

    // eslint-disable-next-line no-unused-vars
    showWebNotification = (notificationDetails) => {
      if (this.state.ignore) {
        return
      }

      const title = "New Meeting";
      const body = "A new meeting has arrived";
      const tag = Date.now();
      const icon = 'http://georgeosddev.github.io/react-web-notification/example/Notifications_button_24.png';


      const options = {
        tag: tag,
        body: body,
        icon: icon,
        lang: 'en',
        dir: 'ltr',
      }

      this.setState({
        title: title,
        options: options
      });
    }

    handleNotSupported = () => {
      console.log("Web Notification not supported on your browser")
      this.setState({
        ignore: true
      });
    }

    handlePermissionGranted = () => {
      console.log('Web Notification Permission Granted');
      this.setState({
        ignore: false
      });
    }

    handlePermissionDenied = () => {
      console.log("Web Notification Permission Denied")
      this.setState({
        ignore: true
      })
    }

    handleNotificationOnShow = (e, tag) => {
      console.log("Web Notification On Show", "Tag : ", tag, "   e : ", e)
    }

    handleNotificationOnClick = (e, tag) => {
      console.log("Web Notification On Show", "Tag : ", tag, "   e : ", e, "notificationDetails:")
      try {
        window.focus();
      }
      catch (error) {
        alert(error);
      }
    }

    handleNotificationOnClose = (e, tag) => {
      console.log("Web Notification On Show", "Tag : ", tag, "   e : ", e)
    }

    handleNotificationOnError = (e, tag) => {
      console.log("Web Notification On Show", "Tag : ", tag, "   e : ", e)
    }

    render() {

      return (
        <div>
          <NotificationSystem ref={(input) => { this.notificationSystem = input }} />
          <Notification
            ignore={this.state.ignore && this.state.title !== ''}
            disableActiveWindow={true}
            notSupported={this.handleNotSupported}
            onPermissionGranted={this.handlePermissionGranted}
            onPermissionDenied={this.handlePermissionDenied}
            onShow={this.handleNotificationOnShow}
            onClick={this.handleNotificationOnClick}
            onClose={this.handleNotificationOnClose}
            onError={this.handleNotificationOnError}
            timeout={5000}
            title={this.state.title}
            options={this.state.options}
          />
        </div>
      )
    }
}

export function Notify() {
  return window.sfcrmdashboard["notification"]
}

export default Notifications


// WEBPACK FOOTER //
// ./src/components/notifications/notifications.js